<template>
  <div class="summary-list">
    <p>
      <span class="title">{{ title }} ({{ totalAmount }})</span><br />
    </p>
    <ul :class="{ collapsed: !isExpanded }">
      <li v-for="item in items" :key="item.name" class="item">
        {{ item.name }}
        <span class="amount"> ({{ item.amount }}) </span>
      </li>
    </ul>
    <a v-if="showToggle" href="#" v-on:click.prevent="toggleExpanded()">
      {{ isExpanded ? 'Show less' : 'Show more' }}
    </a>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'product-list',
  props: {
    title: {
      type: String,
      default: 'All items',
    },
    items: {
      type: Array<{ name: string; amount: number }>,
      default: () => [],
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    totalAmount(): number {
      return (this.items as any).reduce((total: number, item: any) => total + item.amount, 0);
    },
    showToggle(): boolean {
      return this.items.length > 4;
    },
  },
  mounted() {
    // When there is less than 4 items, we show all items. When there
    // is more than 4 items, we show the first three items and a toggle
    // link. This is how we never show more than 4 lines, and never show
    // a toggle link that takes one line, if it would toggle only one
    // line. To achieve this, we need to expand the view when we do not
    // show the toggle:
    if (!this.showToggle) {
      this.isExpanded = true;
    }
  },
  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },
  },
});
</script>

<style scoped lang="scss">
.summary-list {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  padding-bottom: 10px;

  .amount {
    color: var(--primary-text-color);
  }

  a {
    color: var(--primary-text-color);
    text-decoration: underline;
  }

  p {
    margin: 0;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    color: var(--primary-text-color);
    color: var(--primary-text-remark-unselected-color);
    &.collapsed > li:nth-child(n + 4) {
      display: none;
    }
  }
}
</style>
